<template>
  <div
    class="sender-picker-link text-end mb-1"
    @click="fillSender"
  >
    <div>
      {{ $t("Fill with profile data") }}
      <v-icon
        end
        class="icon-flipped"
        color="primary"
        size="22"
      >
        mdi-keyboard-backspace
      </v-icon>
    </div>
  </div>
</template>

<script setup lang="ts">

import { useProfileStore } from '@/stores/profile'
import { storeToRefs } from 'pinia'
import { User } from "@/entities/user";

// Emits
const emit = defineEmits<{
  (e: 'fillSender', profile: User): void
}>()

const props = defineProps<{
  senderData: User | null
}>()

// Stores
const profileStore = useProfileStore()

const { profile } = storeToRefs(profileStore)

// Emit profile on click
function fillSender() {
  if (props.senderData) {
    emit('fillSender', props.senderData)
  }
}
</script>

<style lang="scss">
.sender-picker-link {
  color: rgb(var(--v-theme-primary));

  :hover {
    cursor: pointer;
  }
}
</style>
